export default __webpack_public_path__ + "static/media/click.ef5d0138.wav";